export const RUBROS_ESPECIALIDADES = {
  "🏥 Salud": [
    "Medicina Clínica", "Cardiología", "Neurología", "Traumatología", "Pediatría",
    "Ginecología", "Obstetricia", "Urología", "Dermatología", "Endocrinología",
    "Gastroenterología", "Neumonología", "Otorrinolaringología", "Oftalmología",
    "Oncología", "Reumatología", "Infectología", "Psiquiatría", "Alergología",
    "Nefrología", "Cirugía General", "Medicina Laboral", "Medicina Deportiva",
    "Nutrición", "Psicología", "Psicopedagogía", "Kinesiología", "Fisioterapia",
    "Fonoaudiología", "Terapia Ocupacional", "Laboratorio de Análisis Clínicos",
    "Diagnóstico por Imágenes"
  ],
  "🦷 Odontología": [
    "Odontología General", "Ortodoncia", "Endodoncia", "Implantología", "Periodoncia",
    "Odontopediatría", "Cirugía Maxilofacial", "Prótesis Dental", "Estética Dental"
  ],
  "💄 Estética y Belleza": [
    "Cosmetología", "Cosmiatría", "Depilación Tradicional", "Depilación Definitiva",
    "Manicuría", "Pedicuría", "Nail Art", "Masajes", "Drenaje Linfático",
    "Tratamientos Corporales", "Tratamientos Faciales", "Radiofrecuencia",
    "Criolipólisis", "Peluquería", "Barbería", "Colorimetría", "Maquillaje Profesional",
    "Perfilado de Cejas", "Microblading", "Laminado de Cejas", "Extensión de Pestañas",
    "Lifting de Pestañas"
  ],
  "💇 Peluquería": [
    "Corte Femenino", "Corte Masculino", "Corte Infantil", "Coloración", "Balayage",
    "Mechas", "Alisados", "Botox Capilar", "Tratamientos Capilares", "Peinados",
    "Extensiones"
  ],
  "💈 Barbería": [
    "Corte de Cabello", "Arreglo de Barba", "Afeitado Tradicional", "Coloración",
    "Tratamientos Capilares"
  ],
  "🏋️ Fitness y Bienestar": [
    "Personal Trainer", "Musculación", "Entrenamiento Funcional", "CrossFit",
    "Yoga", "Pilates", "Spinning", "Zumba", "GAP", "Nutrición Deportiva",
    "Evaluación Física"
  ],
  "🐶 Veterinaria": [
    "Clínica Veterinaria", "Vacunación", "Cirugía", "Dermatología Veterinaria",
    "Cardiología Veterinaria", "Traumatología Veterinaria", "Odontología Veterinaria",
    "Ecografía", "Peluquería Canina", "Peluquería Felina"
  ],
  "⚖️ Servicios Profesionales": [
    "Abogado", "Escribano", "Contador", "Auditor", "Asesor Impositivo", "Arquitecto",
    "Ingeniero", "Agrimensor", "Consultor Empresarial", "Coach", "Recursos Humanos",
    "Marketing"
  ],
  "🎓 Educación": [
    "Profesor Particular", "Matemática", "Física", "Química", "Biología",
    "Programación", "Idiomas", "Música", "Apoyo Escolar", "Tutorías Universitarias"
  ],
  "🚗 Automotor": [
    "Mecánica General", "Electricidad Automotriz", "Gomería", "Alineación",
    "Balanceo", "Lavadero", "Polarizado", "Audio Automotor", "Chapa y Pintura",
    "Aire Acondicionado Automotor"
  ],
  "🏠 Servicios para el Hogar": [
    "Electricista", "Plomero", "Gasista", "Cerrajero", "Albañil", "Pintor",
    "Carpintero", "Jardinero", "Limpieza", "Técnico en Aire Acondicionado",
    "Técnico en Electrodomésticos"
  ],
  "📸 Eventos y Producción": [
    "Fotografía", "Video", "DJ", "Organización de Eventos", "Decoración",
    "Catering", "Animación"
  ],
  "🧘 Terapias Alternativas": [
    "Acupuntura", "Reiki", "Reflexología", "Masoterapia", "Flores de Bach",
    "Meditación", "Yoga Terapéutico"
  ],
  "🐾 Servicios para Mascotas": [
    "Paseador", "Adiestrador", "Guardería", "Baño", "Peluquería", "Cuidado a Domicilio"
  ],
  "💉 Enfermería y Atención Domiciliaria": [
    "Enfermería General", "Curaciones", "Vacunación", "Extracción de Sangre",
    "Control de Presión Arterial", "Atención Domiciliaria", "Cuidados Postoperatorios"
  ],
  "👁️ Ópticas y Salud Visual": [
    "Optometría", "Contactología", "Adaptación de Lentes", "Control Visual"
  ],
  "🦻 Audiología": [
    "Audiometría", "Adaptación de Audífonos", "Rehabilitación Auditiva", "Estudios Auditivos"
  ]
};
